module.exports = {
  PREFIX: 'OJ',
};
